import getTimezoneOffset from '../getTimezoneOffset';

const getTimezonesDiff = (timezone1, timezone2, date) => (
  getTimezoneOffset(timezone1, date) - getTimezoneOffset(timezone2, date)
);

export default getTimezonesDiff;
